import { render } from "./LogoWithDescription.vue?vue&type=template&id=04120507&scoped=true"
import script from "./LogoWithDescription.vue?vue&type=script&lang=js"
export * from "./LogoWithDescription.vue?vue&type=script&lang=js"

import "./LogoWithDescription.vue?vue&type=style&index=0&id=04120507&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04120507"]])

export default __exports__